import NewSKUDetected from "./NewSKUDetected";
export default NewSKUDetected;
